/* eslint-disable */
import styled from "styled-components";
import React, { memo, useEffect, useState } from "react";
import EVC_GIF_ICON from "../../assets/images/EVC-fan-gif.gif";
import EVC_ICON from '../../assets/images/EVC-fan.png';
import { getFlexWidth } from "../../actions/passwordRegex";
import {
  getStringFromDecimalToBinary
} from "../../helpers";
import CommonDisplay from "./CommonDisplay";
import { EVC_LISTINGS_LIMIT } from "../../constants";


const GraphTypeWrapper = styled.div`
  // overflow: ${({ numDevices }) => (numDevices >= 7 ? "scroll" : "initial")};
  // white-space: ${({ numDevices }) => (numDevices >= 7 ? "nowrap" : "initial")};
  // flex: ${({ numDevices }) => `0 0 ${getFlexWidth(numDevices)}%`};
  // img {
  //   position: relative;
  //   width: 35px;
  //   cursor: pointer;
  // }
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const TankDevices = memo(
  ({
    currentTankData,
    tankType,
    setDeviceId,
    deviceType,
    deviceTypeGlobal,
    deviceId,
    setDeviceType,
    deviceIdObj,
    tankDeviceType,
    setCurrentActiveView,
    chillerAlertsList,
    turckTankName,
    turckControlSerialNumber
  }) => {
    const [currentEnableDeviceIDs, setCurrentEnableDeviceIDs] = useState(deviceIdObj);
    const [isFanRotating, setIsFanRotating] = useState(Array.from('0'.repeat(EVC_LISTINGS_LIMIT)));
    const [showAlertIcon, setShowAlertIcon] = useState({});
    const [evcAlertsByDeviceID, setEvcAlertsByDeviceID] = useState([])

    useEffect(() => {
      // filtering only enable devices whenever live data emits
      if (currentTankData?.CHILLER && deviceIdObj?.CHILLER?.length && deviceIdObj?.EVC?.length && Object.keys(currentTankData.CHILLER).length) {
        const EVCDeviceIdsList = [];
        const compressorBits = [];
        for (let i = 0; i < EVC_LISTINGS_LIMIT; i++) {
          const isCompressorEnabled = Number(currentTankData?.CHILLER?.[deviceIdObj?.CHILLER?.[0]]?.[`CHILLER_CONTROLLER_HOLD_REG_STAGE_${i + 1}_ENABLED_PARAM`])
          const EVCs = Object.keys(currentTankData?.["EVC"]);
          if (isCompressorEnabled) {
            const EVCDeviceData = {
                evcDeviceID: EVCs[i],
                compressorIndex: i,
                deviceNo: currentTankData?.EVC[EVCs[i]]?.device,
            };
            EVCDeviceIdsList.push(EVCDeviceData);
          }

          if(i + 1 > 6 && isCompressorEnabled) {
            compressorBits.push("1");
          }
                  }
        const relayStatusCompressorBits = getStringFromDecimalToBinary(currentTankData?.CHILLER?.[deviceIdObj?.CHILLER?.[0]]?.[`CHILLER_CONTROLLER_HOLD_REG_ONBOARD_RELAY_STATUS`]).slice(4, 10)
        setCurrentEnableDeviceIDs({ ...deviceIdObj, "EVC": EVCDeviceIdsList });
                setIsFanRotating([...relayStatusCompressorBits, ...compressorBits])
      }

      // when device is offline and on page load setting evc obj
      if(!Object.keys(currentTankData).length && Object.keys(deviceIdObj).length && deviceIdObj?.EVC?.length) {
        const EVCDeviceIdsList = [];
        for(let i = 0; i < deviceIdObj.EVC.length; i++) {
          EVCDeviceIdsList.push({ evcDeviceID: deviceIdObj.EVC[i], compressorIndex: i })
        }
        setCurrentEnableDeviceIDs({ ...deviceIdObj, "EVC": EVCDeviceIdsList });
      }
    }, [currentTankData, deviceIdObj]);

    function detectAlerts() {
      if (!chillerAlertsList.length) {
        // NO ALERTS FOUND;
        return;
      }
      const alertsByEvcDeviceID = []
      const updatedAlertIcons = {};

      for (let compressorIndex = 0; compressorIndex < EVC_LISTINGS_LIMIT; compressorIndex++) {
        updatedAlertIcons[compressorIndex] = { chillerDeviceSerialNumber: null, status: false };

        if (!chillerAlertsList.length) {
          break;
        }

        for (let chillerAlert of chillerAlertsList) {
          if (chillerAlert?.alertType?.includes('INDIVIDUAL') &&
            (
              chillerAlert?.configKey === `CHILLER_CONTROLLER_INPUT_REG_ALARMS_ACTIVE_1_BIT_${compressorIndex + 10}` ||
              chillerAlert?.configKey === `CHILLER_CONTROLLER_INPUT_REG_ALARMS_ACTIVE_2_BIT_${compressorIndex}`
            )
          ) {
            updatedAlertIcons[compressorIndex] = {
              chillerDeviceSerialNumber: chillerAlert.deviceSerialNumber,
              status: true,
            };
            break;
          }
        }
      }
      setShowAlertIcon(updatedAlertIcons);

      for (const chillerAlert of chillerAlertsList) {
        if(chillerAlert.deviceType === "EVC") {
          if(chillerAlert.alertType.includes("INDIVIDUAL") && chillerAlert.configKey.includes("EVC_INPUT_STATUS_REGISTER")) {
            alertsByEvcDeviceID.push(chillerAlert.deviceSerialNumber);
          }
        }
      }
      setEvcAlertsByDeviceID(alertsByEvcDeviceID);
    }

    useEffect(() => {
      detectAlerts();
    }, [chillerAlertsList]);

    return (
      <GraphTypeWrapper
        numDevices={
          deviceIdObj ? deviceIdObj.EVC.length + (deviceTypeGlobal === "HPF" ? deviceIdObj.HPF.length :  deviceTypeGlobal === 'CHILLER' ? deviceIdObj.CHILLER.length: deviceIdObj.TURCK_TANKS?.length) : 0
        }
      >
        {
          (deviceTypeGlobal === "HPF" || deviceTypeGlobal === "TURCK_TANKS")
            ?
            (deviceIdObj &&
              Object.keys(deviceIdObj).map((key) => {
                return deviceIdObj[key].map((id, index) => {
                  const evcIcon = Number.parseInt(currentTankData?.EVC?.[id]?.RUN_SIGNAL) === 1 ? EVC_GIF_ICON : EVC_ICON;

                  return (
                    <CommonDisplay
                      deviceId={deviceId}
                      id={id}
                      deviceKey={key}
                      deviceTypeGlobal={deviceTypeGlobal}
                      setDeviceId={setDeviceId}
                      setDeviceType={setDeviceType}
                      setCurrentActiveView={setCurrentActiveView}
                      deviceType={deviceType}
                      tankType={tankType}
                      evcIcon={evcIcon}
                      tankDeviceType={tankDeviceType}
                      currentTankData={currentTankData}
                      turckTankName={turckTankName}
                      turckControlSerialNumber={turckControlSerialNumber}
                    />
                  );
                });
              }))
            : deviceTypeGlobal === "CHILLER" ?
              (currentEnableDeviceIDs &&
                Object.keys(currentEnableDeviceIDs).map((key) => {
                  if (key === "CHILLER") {
                    return currentEnableDeviceIDs[key].map((id, index) => {
                      return (
                        <CommonDisplay
                          deviceId={deviceId}
                          id={id}
                          deviceKey={key}
                          deviceTypeGlobal={deviceTypeGlobal}
                          setDeviceId={setDeviceId}
                          setDeviceType={setDeviceType}
                          setCurrentActiveView={setCurrentActiveView}
                          deviceType={deviceType}
                          tankType={tankType}
                          tankDeviceType={tankDeviceType}
                          currentTankData={currentTankData}
                        />
                      );
                    });
                  }

                  return currentEnableDeviceIDs[key].map(({ evcDeviceID, compressorIndex, deviceNo }, index) => {
                    const evcRotateSignal = Number(isFanRotating[index])
                    const evcDisabledSignal = Number.parseInt(currentTankData?.CHILLER?.[deviceIdObj?.CHILLER?.[0]]?.[`CHILLER_CONTROLLER_HOLD_REG_COMPRESSOR_${deviceNo}_EVC_ENABLED_PARAM`]) === 0
                    const evcIcon = evcRotateSignal ? EVC_GIF_ICON : EVC_ICON;
                    const isIndividualEvcAlertResolved = evcAlertsByDeviceID.includes(evcDeviceID);
                    const alertIcon = (showAlertIcon[compressorIndex]?.status && currentEnableDeviceIDs.CHILLER[0] === showAlertIcon[compressorIndex]?.chillerDeviceSerialNumber) || isIndividualEvcAlertResolved || false;
                    let stageIndex = Number(currentTankData?.CHILLER?.[deviceIdObj?.CHILLER?.[0]]?.[`CHILLER_CONTROLLER_INPUT_REG_STAGE_${deviceNo}_COMPRESSOR`]) + 1;
                    return (
                      <CommonDisplay
                        deviceId={deviceId}
                        id={evcDeviceID}
                        deviceKey={key}
                        deviceTypeGlobal={deviceTypeGlobal}
                        evcDisabledSignal={evcDisabledSignal}
                        index={compressorIndex}
                        setDeviceId={setDeviceId}
                        setDeviceType={setDeviceType}
                        setCurrentActiveView={setCurrentActiveView}
                        deviceType={deviceType}
                        tankType={tankType}
                        evcIcon={evcIcon}
                        stageIndex={stageIndex}
                        tankDeviceType={tankDeviceType}
                        currentTankData={currentTankData}
                        alertIcon={alertIcon}
                      />
                    );
                  });
                })) : null
        }

      </GraphTypeWrapper>
    );
  }
);

export default TankDevices;
